export default __webpack_public_path__ + "static/media/1422.a52bd9f0.png";